import {
  useQuery,
  useQueryClient,
  UseQueryResult,
} from "@tanstack/react-query";
import useProfile from "../useProfile";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";
import { AxiosResponse } from "axios";
import { useContext } from "react";
import { ApplicationState } from "../../../context/ApplicationStateContext";
interface SyncAssociationsResponse extends AxiosResponse {
  data: {
    reFetch: boolean;
  };
}

function useSyncAssociations(): UseQueryResult<SyncAssociationsResponse> {
  const { data: profile, isLoading } = useProfile();
  const {
    dispatch,
    state: { syncSuccess },
  } = useContext(ApplicationState);
  const authState = useOktaAuth()?.authState;
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: ["syncAssociations", { userId: profile?.user?.id }],
    queryFn: ({ queryKey }) => {
      const [_key, { userId }]: any = queryKey;
      return axiosInstance
        .post(`/v1/users/sync-associations`, userId, {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        })
        .then((res: SyncAssociationsResponse) => {
          const { data } = res;
          if (data.reFetch) {
            queryClient.refetchQueries({
              queryKey: [
                "organizations",
                "pathLabs",
                "profile",
              ],
            });
          }
          dispatch({ type: "SET_SYNC_STATE", payload: true });
          queryClient.refetchQueries({
            queryKey: [
              "profile",
            ],
          });
        });
    },
    enabled:
      !!authState?.accessToken?.accessToken &&
      !!profile?.user?.id &&
      !syncSuccess,
  });
}

export default useSyncAssociations;
